import React from "react";

export default function Marquee({ words = [] }) {
  const repeat = [...words, ...words, ...words];
  return (
    <div className="marquee" data-testid="marquee">
      <div className="marquee-track">
        {repeat.map((w, i) => (
          <span key={i}>★ {w}</span>
        ))}
      </div>
    </div>
  );
}
